export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10943.d3f7848d.jpg";